import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {FormBuilder} from '@angular/forms';
import {PlatformQueryService} from '@core/services/platform-query.service';

@Component({
    standalone: false,
    selector: 'app-pause-resume-oic-workflow-dialog',
  templateUrl: './pause-resume-oic-workflow-dialog.component.html',
  styleUrls: ['./pause-resume-oic-workflow-dialog.component.scss']
})
export class PauseResumeOicWorkflowDialogComponent implements OnInit, IDialogView, OnDestroy {
  inputForm: any;
  data: DialogModel;
  oicReturnFilterOptions: any[] = [];
  selectedFilterOption: string;
  private ngUnsubscribe = new Subject<void>();

  constructor(private formBuilder: FormBuilder,
              private platformQueryService: PlatformQueryService,
  ) {
    this.inputForm = this.formBuilder.group({
      oicFilterOptions: ['']
    });
  }

  ngOnInit(): void {
    this.oicReturnFilterOptions = this.data.input.oicReturnFilterOptions;
    this.selectedFilterOption = this.oicReturnFilterOptions[0].key;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onOkClicked(): boolean {
    this.data.input['selectedFilterOption'] = this.selectedFilterOption;
    return true;
  }
}
